import { render, staticRenderFns } from "./stepFour.vue?vue&type=template&id=5cf02f4e&scoped=true"
import script from "./stepFour.vue?vue&type=script&lang=js"
export * from "./stepFour.vue?vue&type=script&lang=js"
import style0 from "./stepFour.vue?vue&type=style&index=0&id=5cf02f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf02f4e",
  null
  
)

export default component.exports